<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data: function () {
    return {};
  },
  created: function () {
    // PC端
    // window.localStorage.setItem("appId_AI", "lzpc");
    // window.localStorage.setItem("userId_AI", "4967609203406405639");
    // window.localStorage.setItem("clientType_AI", "pc");
    // window.localStorage.setItem(
    //   "sessionId_AI",
    //   "99653b56e8ded9820df35dbd126942a5"
    // );
    // window.localStorage.setItem("channelCode_AI", "lzpc");

    // 拼吧小程序
    // window.localStorage.setItem("appId_AI", "cstmbus.user.h5");
    // window.localStorage.setItem("userId_AI", "32064923805852009234762");
    // window.localStorage.setItem("clientType_AI", "wechat");
    // window.localStorage.setItem(
    //   "sessionId_AI",
    //   "8963719219453bcd58d387f3e4d0099c"
    // );
    // window.localStorage.setItem(
    //   "sessionId",
    //   "8963719219453bcd58d387f3e4d0099c"
    // );
    // window.localStorage.setItem("channelCode_AI", "pinba");

    // 南通 小程序
    // window.localStorage.setItem("appId_AI", "com.brightcns.cxnt.wxmp");
    // window.localStorage.setItem("userId_AI", "32064941085747760332903");
    // window.localStorage.setItem("clientType_AI", "wechat");
    // window.localStorage.setItem(
    //   "sessionId_AI",
    //   "af5e07677cd2b056e5a59da317487cd4"
    // );
    // window.localStorage.setItem(
    //   "sessionId",
    //   "6cdeec35b4252e36bed8e484d88f988f"
    // );
    // window.localStorage.setItem("channelCode_AI", "cxnt");

    // 柳州 小程序
    // window.localStorage.setItem("appId_AI", "com.brightcns.dxlc.wxmp");
    // window.localStorage.setItem("userId_AI", "54504933647993980059702");
    // window.localStorage.setItem("clientType_AI", "wechat");
    // window.localStorage.setItem(
    //   "sessionId_AI",
    //   "90a62d4662b3ee6be4f4f0759fad7e30"
    // );
    // window.localStorage.setItem(
    //   "sessionId",
    //   "7f221e1d552414e437ffa816e6673ccc"
    // );
    // window.localStorage.setItem("channelCode_AI", "dxlc");

    // 柳州app
    // window.localStorage.setItem("appId_AI", "com.brightcns.dxlc");
    // window.localStorage.setItem("userId_AI", "54504968714829993869389");
    // window.localStorage.setItem("clientType_AI", "app");
    // window.localStorage.setItem(
    //   "sessionId_AI",
    //   "df8cf6726a56abf428780cceee555586"
    // );
    // window.localStorage.setItem(
    //   "sessionId",
    //   "713afd48577e362a2bc4ca3940370408"
    // );
    // window.localStorage.setItem("channelCode_AI", "dxlc");

    // 判断当前env是否是小程序环境
    if (window.__wxjs_environment) {
      this.$store.commit("isWechatProgram", true);
    }
    // 这里在判断一次 将最终状态存入仓库
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.$store.commit("IsAndroid");
    }
    if (isIos) {
      this.$store.commit("IsIos");
    }
    this.$router.beforeEach((to, from, next) => {
      console.log("路由跳转了", to);
      if (!to.query.noChangeName) {
        window.document.title = to.meta.title || "";
      }
      next();
    });
  },
};
</script>

<style lang="scss">
.isExpire {
  opacity: 0.3 !important;
}

.viewer-backdrop {
  background-color: #000 !important;
}
.viewer-close {
  display: none !important;
}
.viewer-container {
  z-index: 1000 !important;
}
@import "./common/scss/rem";
@import "./common/scss/theme";
.van-toast {
  z-index: 9999 !important;
}
* {
  padding: 0;
  margin: 0;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica,
    Segoe UI, Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB",
    "Microsoft Yahei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

html,
body,
#app {
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.van-popup {
  background: transparent;
}

.businessContent {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.businessText {
  color: var(--Tokens-Text-primary, #28282d);
  font-size: 16px;
  line-height: 24px;
}

.tagA {
  color: var(--Tokens-Color-hover, #0a52eb);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

pre {
  white-space: pre-wrap !important;
  word-break: break-word !important;
}

.width100 {
  width: 100%;
}

.autoWitdh_image {
}

.vc-switch,
.vc-panel {
  position: fixed !important  ;
  z-index: 99999 !important;
}
// 首页背景色

@media screen and (max-width: 667px) {
  .autoWidth_image {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.autoWidth_image {
  max-width: 50%;
}
</style>
